// import { lazy, Suspense } from "react";
import React from "react";
import "./App.css";

import ToDo from "./Components/ToDo"
function App() {
    
    
  return (
   <main>
     <ToDo></ToDo>
   </main>
  );
}

export default App;
